var map = {
	"./benefits.png": 2888,
	"./benefits.svg": 73900,
	"./bills.png": 64672,
	"./bills.svg": 56782,
	"./charity.png": 62958,
	"./charity.svg": 65040,
	"./check tick.png": 99963,
	"./clothes.png": 30726,
	"./clothes.svg": 4640,
	"./clothing.png": 45664,
	"./clothing.svg": 42964,
	"./coffee.png": 30916,
	"./coffee.svg": 48484,
	"./coffees.png": 82037,
	"./coffees.svg": 3023,
	"./creditcards.png": 67894,
	"./creditcards.svg": 57068,
	"./dark_excludedfromanalysisicon.png": 58614,
	"./dark_excludedfromanalysisicon.svg": 61516,
	"./debts.png": 87600,
	"./debts.svg": 32718,
	"./drinks.png": 31413,
	"./drinks.svg": 99025,
	"./eatingout.png": 13104,
	"./eatingout.svg": 92030,
	"./education.png": 49768,
	"./education.svg": 74170,
	"./entertainment.png": 85852,
	"./entertainment.svg": 85714,
	"./essentials.png": 20495,
	"./essentials.svg": 37407,
	"./family.png": 73036,
	"./family.svg": 4472,
	"./fitness.png": 67106,
	"./fitness.svg": 93672,
	"./future.png": 3093,
	"./future.svg": 83845,
	"./gambling.png": 24937,
	"./gambling.svg": 60361,
	"./general.png": 72038,
	"./general.svg": 62464,
	"./gifts.png": 74283,
	"./gifts.svg": 42389,
	"./groceries.png": 16491,
	"./groceries.svg": 75757,
	"./health.png": 29130,
	"./health.svg": 71290,
	"./hobbies.png": 23354,
	"./hobbies.svg": 77368,
	"./holiday.png": 17286,
	"./holiday.svg": 30860,
	"./home&garden.png": 18468,
	"./home&garden.svg": 44186,
	"./home.png": 75341,
	"./home.svg": 39389,
	"./income.png": 74861,
	"./income.svg": 21337,
	"./insurance.png": 23426,
	"./insurance.svg": 83412,
	"./insurances.png": 71603,
	"./insurances.svg": 92639,
	"./insurnace.png": 94360,
	"./insurnace.svg": 11206,
	"./interest.png": 58286,
	"./interest.svg": 52990,
	"./internaltransfers.png": 31975,
	"./internaltransfers.svg": 86009,
	"./internaltransfersicon.png": 66708,
	"./internaltransfersicon.svg": 33990,
	"./investments.png": 3840,
	"./investments.svg": 70678,
	"./largepurchases.png": 33835,
	"./largepurchases.svg": 10459,
	"./lifestyle.png": 45959,
	"./lifestyle.svg": 26493,
	"./list.png": 80948,
	"./medical.png": 25923,
	"./medical.svg": 16381,
	"./mortgage.png": 33658,
	"./mortgage.svg": 73470,
	"./other.png": 26488,
	"./other.svg": 5574,
	"./pension in.png": 34287,
	"./pension in.svg": 23007,
	"./pension out.png": 6768,
	"./pension out.svg": 12330,
	"./pensionin.png": 43305,
	"./pensionin.svg": 93051,
	"./pensionout.png": 13982,
	"./pensionout.svg": 88126,
	"./pets.png": 43634,
	"./pets.svg": 76730,
	"./plus.png": 72792,
	"./rent.png": 70169,
	"./rent.svg": 65241,
	"./resources.png": 36129,
	"./resources.svg": 84839,
	"./salary.png": 29726,
	"./salary.svg": 63558,
	"./savings.png": 6519,
	"./savings.svg": 38693,
	"./selfcare.png": 44765,
	"./selfcare.svg": 25817,
	"./shopping.png": 23840,
	"./shopping.svg": 87820,
	"./socialising.png": 11561,
	"./socialising.svg": 77411,
	"./sports and fitness.png": 88386,
	"./sports and fitness.svg": 52638,
	"./sportsandfitness.png": 99044,
	"./sportsandfitness.svg": 77964,
	"./swipe.png": 32572,
	"./takeaways.png": 53448,
	"./takeaways.svg": 1822,
	"./tick.png": 35163,
	"./transfers.png": 22394,
	"./transfers.svg": 93272,
	"./transport.png": 32177,
	"./transport.svg": 40231,
	"./travel.png": 52908,
	"./travel.svg": 12668,
	"./uncategorised.png": 89969,
	"./uncategorised.svg": 25871,
	"./vehicle.png": 23706,
	"./vehicle.svg": 59544,
	"./withdrawals-1.png": 10716,
	"./withdrawals-1.svg": 91930,
	"./withdrawals.png": 54246,
	"./withdrawals.svg": 6452,
	"./work.png": 11575,
	"./work.svg": 57999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21530;